import { IDonHangChiTietActions } from "../../action-types/don-hang/IDonHangChiTietActions";
import { IDonHangChiTietReducer } from "../../reducer-model/don-hang/IDonHangChiTietReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IDonHangChiTietReducer = {
    status: eReducerStatusBase.is_not_initialization,
    donHangId: null, // id của đơn hàng
    donHangChiTiets: [],
    isShowEditModal: false,
    trangThaiSelectedIds: []
};

export const donHangChiTietReducer = (state: IDonHangChiTietReducer = iniState, action: IDonHangChiTietActions): IDonHangChiTietReducer => {
    switch (action.type) {
        case "DON_HANG_CHI_TIET_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "DON_HANG_CHI_TIET_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                donHangChiTiets: action.payload
            };
        case "DON_HANG_CHI_TIET_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "DON_HANG_CHI_TIET_LOAD_DON_HANG_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
                donHangId: action.payload
            };
        case "DON_HANG_CHI_TIET_LOAD_DON_HANG_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                donHangChiTiets: action.payload
            };
        case "DON_HANG_CHI_TIET_LOAD_DON_HANG_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "DON_HANG_CHI_TIET_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                donHangChiTietEditing: action.payload
            };
        case "DON_HANG_CHI_TIET_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "DON_HANG_CHI_TIET_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            };
        case "DON_HANG_CHI_TIET_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                status: eReducerStatusBase.is_need_reload
            };
        case "DON_HANG_CHI_TIET_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "DON_HANG_CHI_TIET_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            };
        case "DON_HANG_CHI_TIET_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            };
        case "DON_HANG_CHI_TIET_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "DON_HANG_CHI_TIET_CHANGED_TRANGTHAI_SELECTED_IDS":
            return {
                ...state,
                trangThaiSelectedIds: action.payload
            };
        default:
            return state;
    }
};
